import requestv2 from "~/utils/http-v2";

const groupApi = {
	gets : async (params) => {
		const url = 'v2/groups';
		return await requestv2.get(url, {params});
	},
	all : async (params) => {
		const url = 'v2/groups/all';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/groups';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/groups/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/groups/${id}`;
		return await requestv2.delete(url);
	}
};

export default groupApi;